import { render, staticRenderFns } from "./vBanner.vue?vue&type=template&id=44b53716"
import script from "./vBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./vBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports